module.exports = __webpack_public_path__ + "static/img/sg_btn1.6b67f25.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/role3/control/sg_btn1.png
// module id = pdF7
// module chunks = 7